"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _checkmark = _interopRequireDefault(require("@spothero/icons/checkmark"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Checkbox extends _react.PureComponent {
  static defaultProps = {
    value: 'on',
    icon: /*#__PURE__*/_react.default.createElement(_checkmark.default, null)
  };
  constructor(props) {
    super(props);
    const {
      id,
      toggle,
      label
    } = props;
    this.state = {
      validationState: null
    };
    if (!id) {
      throw new Error(`The prop 'id' is required to make Checkbox accessible for users using assistive technologies such as screen readers. Check the render method of Checkbox.`);
    }
    if (!toggle && !label) {
      throw new Error(`The label prop is required when using a Checkbox that isn't a toggle.`);
    }
  }
  componentDidMount() {
    this._input.addEventListener('invalid', this._onInvalid);
  }
  componentWillUnmount() {
    this._input.removeEventListener('invalid', this._onInvalid);
  }
  _onInvalid = evt => {
    evt.preventDefault();
    const {
      onInvalid
    } = this.props;
    const validationState = evt.currentTarget.validity;
    this.setState({
      validationState
    });
    if (onInvalid) {
      onInvalid(validationState);
    }
  };
  _onChange = evt => {
    const {
      onChange
    } = this.props;
    this.setState({
      validationState: null
    });
    if (onChange) {
      onChange(evt);
    }
  };
  _renderIcon() {
    return this.props.icon;
  }
  render() {
    const {
      label,
      className,
      name,
      id,
      value,
      defaultChecked,
      required,
      disabled,
      toggle,
      error
    } = this.props;
    const {
      validationState
    } = this.state;
    const isValid = validationState ? validationState.valid : true;
    const classes = (0, _classnames.default)('Checkbox', {
      'Checkbox-toggle': toggle
    }, 'FormElement', {
      'FormElement-contains-error': !isValid
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-control"
    }, /*#__PURE__*/_react.default.createElement("input", {
      ref: node => {
        this._input = node;
      },
      id: `Checkbox-${id}`,
      className: "FormElement-item",
      type: "checkbox",
      name: name,
      defaultChecked: defaultChecked,
      required: required,
      disabled: disabled,
      value: value,
      onChange: this._onChange
    }), this._renderIcon(), !toggle && /*#__PURE__*/(0, _react.cloneElement)(label, {
      htmlFor: `Checkbox-${id}`
    }), toggle && /*#__PURE__*/_react.default.createElement("span", {
      className: "Label"
    })), !isValid && error);
  }
}
exports.default = Checkbox;